<template>
  <section>
    <v-footer app class="pt-3 d-print-none">
      <v-btn
        v-show="paso > 1"
        color="secondary"
        x-large
        v-if="!muestraID"
        @click.prevent="anterior"
        >Anterior <v-icon>chevron_left</v-icon></v-btn
      >
      <v-btn
        v-if="!!muestraID"
        color="secondary"
        x-large
        @click.prevent="regresar"
        >Regresar <v-icon>chevron_left</v-icon></v-btn
      >
      <v-spacer></v-spacer>
      <v-btn
        v-show="false"
        class="mr-5"
        color="primary"
        x-large
        @click.prevent="imprimir"
        v-if="!!muestraID && soloLectura"
        ><v-icon>print</v-icon> Imprimir
      </v-btn>
      <v-btn
        class="mr-5"
        color="primary"
        x-large
        @click.native="soloLectura = false"
        v-if="!!muestraID && soloLectura"
        ><v-icon>edit</v-icon> Editar
      </v-btn>
      <v-btn
        color="primary"
        x-large
        @click.prevent="siguiente"
        v-if="
          paso < 4 &&
            !(!this.solicitud.AnalisisPCR && this.paso === 3) &&
            !muestraID
        "
        ><v-icon>chevron_right</v-icon> Siguiente
      </v-btn>
      <v-btn
        color="primary"
        x-large
        @click.prevent="siguiente"
        v-else-if="!muestraID"
        ><v-icon>save</v-icon> Guardar
      </v-btn>
      <v-btn
        class="mr-5"
        x-large
        @click.prevent="descartar"
        v-if="!!muestraID && !soloLectura"
        ><v-icon>close</v-icon> Descartar
      </v-btn>
      <v-btn
        color="primary"
        x-large
        @click.prevent="actualizarMuestra"
        v-if="!!muestraID && !soloLectura"
        ><v-icon>save</v-icon> Guardar
      </v-btn>
    </v-footer>
    <v-layout row wrap class="d-print-none">
      <v-flex xs12>
        <v-stepper v-model="paso">
          <v-stepper-header>
            <v-stepper-step
              :step="1"
              :complete="this.completos['1']"
              :complete-icon="'done'"
              :editable="!!muestraID"
            >
              Datos del Solicitante
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :step="2"
              :complete="this.completos['2']"
              :editable="!!muestraID"
            >
              Datos de Pago
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :step="3"
              :complete="this.completos['3']"
              :editable="!!muestraID"
            >
              Datos de la Muestra
            </v-stepper-step>

            <template v-if="requiereINDRE">
              <v-divider></v-divider>

              <v-stepper-step :step="4" :editable="!!muestraID">
                Encuesta INDRE
              </v-stepper-step>
            </template>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
    </v-layout>
    <v-form ref="formGenerales" v-show="paso == 1" class="d-print-block">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="text-h4 primary--text">
              Datos Generales
              <v-spacer />
              <v-btn v-if="false" fab color="primary" x-small>
                <v-icon color="white">
                  search
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Nombre(s):
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    @change="actualizarCURP"
                    :rules="[() => !!solicitud.Nombres || 'Campo requerido']"
                    v-model="solicitud.Nombres"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Primer Apellido:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    @change="actualizarCURP"
                    :rules="[
                      () => !!solicitud.PrimerApellido || 'Campo requerido',
                    ]"
                    v-model="solicitud.PrimerApellido"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Segundo Apellido:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    @change="actualizarCURP"
                    :rules="[
                      () => !!solicitud.SegundoApellido || 'Campo requerido',
                    ]"
                    v-model="solicitud.SegundoApellido"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Fecha de Nacimiento:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <datepicker
                    :readonly="soloLectura"
                    @change="actualizarCURP"
                    :rules="[
                      () => !!solicitud.FechaNacimiento || 'Campo requerido',
                    ]"
                    v-model="solicitud.FechaNacimiento"
                  ></datepicker>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Género:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-autocomplete
                    :readonly="soloLectura"
                    @change="actualizarCURP"
                    :items="catalogos.Generos"
                    item-text="Genero"
                    item-value="GeneroID"
                    :rules="[() => !!solicitud.Genero || 'Campo requerido']"
                    v-model="solicitud.Genero"
                    hide-details="auto"
                    :return-object="true"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Estado de Nacimiento:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-autocomplete
                    :readonly="soloLectura"
                    @change="estadoCambiado"
                    :items="catalogos.Estados"
                    item-text="Estado"
                    item-value="EstadoID"
                    :rules="[
                      () => !!solicitud.NacimientoEstado || 'Campo requerido',
                    ]"
                    v-model="solicitud.NacimientoEstado"
                    hide-details="auto"
                    :return-object="true"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  CURP:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    v-model="solicitud.CURP"
                    :rules="[() => !!solicitud.CURP || 'Campo requerido']"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card style="height: 100%;">
            <v-card-title class="text-h4 primary--text">
              Datos de Contacto
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Teléfono:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    type="number"
                    :readonly="soloLectura"
                    :rules="[
                      () =>
                        !solicitud.TelefonoParticular ||
                        String(solicitud.TelefonoParticular).length === 10 ||
                        'Ingrese teléfono 10 dígitos',
                    ]"
                    v-model="solicitud.TelefonoParticular"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Celular:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[
                      () =>
                        !solicitud.Celular ||
                        String(solicitud.Celular).length === 10 ||
                        'Ingrese 10 dígitos',
                    ]"
                    v-model="solicitud.Celular"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Correo de confirmación de cita o personal:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[
                      () =>
                        validarEmail(solicitud.CorreoCita) ||
                        'Ingrese un correo válido',
                    ]"
                    v-model="solicitud.CorreoCita"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Correo Resultados:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-text-field
                    :rules="[
                      () =>
                        validarEmail(solicitud.CorreoResultados) ||
                        'Ingrese un correo válido',
                    ]"
                    :readonly="soloLectura"
                    v-model="solicitud.CorreoResultados"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title class="text-h4 primary--text">
              Domicilio de residencia
            </v-card-title>
            <v-card-text grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md2 class="text-h5 pt-4 pl-5">
                  Alcaldía / Municipio:
                </v-flex>
                <v-flex xs12 md4 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[
                      () =>
                        !!solicitud.DelegacionMunicipio || 'Campo requerido',
                    ]"
                    v-model="solicitud.DelegacionMunicipio"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 class="text-h5 pt-4 pl-5">
                  Estado:
                </v-flex>
                <v-flex xs12 md4 class="pr-5">
                  <v-autocomplete
                    :readonly="soloLectura"
                    :items="catalogos.Estados"
                    item-value="EstadoID"
                    item-text="Estado"
                    hide-details="auto"
                    :rules="[
                      () => !!solicitud.DomicilioEstado || 'Campo requerido',
                    ]"
                    v-model="solicitud.DomicilioEstado"
                    :return-object="true"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md2 class="text-h5 pt-4 pl-5">
                  CP:
                </v-flex>
                <v-flex xs12 md4 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    type="number"
                    hide-details="auto"
                    :rules="[
                      () => !!solicitud.CodigoPostal || 'Campo requerido',
                    ]"
                    v-model="solicitud.CodigoPostal"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="formPago" v-show="paso == 2" class="d-print-block">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card style="height: 100%;">
            <v-card-title class="text-h4 primary--text">
              Forma de Pago
            </v-card-title>
            <v-card-text
              ><v-radio-group
                :readonly="soloLectura"
                :rules="[
                  () => solicitud.PagoTipoID != null || 'Campo requerido',
                ]"
                v-model="solicitud.PagoTipoID"
              >
                <v-layout row wrap>
                  <v-flex
                    xs12
                    md4
                    v-for="tp in catalogos.PagosTipos"
                    :key="tp.PagoTipoID"
                  >
                    <v-radio :label="tp.Pago" :value="tp.PagoTipoID"></v-radio>
                  </v-flex>
                </v-layout>
              </v-radio-group>
              <v-layout row v-if="solicitud.PagoTipoID === 5">
                <v-flex xs12 md4 class="text-h5 pt-4 pl-5">
                  Convenio:
                </v-flex>
                <v-flex xs12 md8 class="pr-5">
                  <v-text-field
                    :readonly="soloLectura"
                    hide-details="auto"
                    :rules="[
                      () => !!solicitud.ConvenioNombre || 'Campo requerido',
                    ]"
                    v-model="solicitud.ConvenioNombre"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="text-h4 primary--text">
              Datos de Facturación
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 class="text-h5 pt-4 pl-5">
                  <v-checkbox
                    :readonly="soloLectura"
                    label="Requiere Factura"
                    v-model="solicitud.RequiereFactura"
                  >
                  </v-checkbox>
                </v-flex>
                <template v-if="solicitud.RequiereFactura">
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Razón Social:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !solicitud.RequiereFactura ||
                          !!solicitud.RazonSocial ||
                          'Campo requerido',
                      ]"
                      v-model="solicitud.RazonSocial"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    RFC:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !solicitud.RequiereFactura ||
                          !!solicitud.RFC ||
                          'Campo requerido',
                      ]"
                      v-model="solicitud.RFC"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Domicilio Fiscal:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !solicitud.RequiereFactura ||
                          !!solicitud.DomicilioFiscal ||
                          'Campo requerido',
                      ]"
                      v-model="solicitud.DomicilioFiscal"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    Correo Factura:
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      :rules="[
                        () =>
                          !solicitud.RequiereFactura ||
                          validarEmail(solicitud.CorreoFactura) ||
                          'Ingrese un correo válido',
                      ]"
                      v-model="solicitud.CorreoFactura"
                      hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                </template>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="formMuestra" v-show="paso == 3" class="d-print-block">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="text-h4 primary--text">
              Datos de la Muestra
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 class="text-h5 pt-4 pl-5">
                  Tipos de Análisis:
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  PCR:
                </v-flex>
                <v-flex xs12 md9 class="pr-5" row>
                  <v-checkbox
                    :readonly="soloLectura"
                    v-model="solicitud.AnalisisPCR"
                  />
                  <v-text-field
                    type="number"
                    v-if="solicitud.AnalisisPCR"
                    :readonly="soloLectura"
                    v-model="solicitud.CodigoBarrasPCR"
                    :rules="[
                      () =>
                        (!!solicitud.CodigoBarrasPCR &&
                          String(solicitud.CodigoBarrasPCR).length <= 10 &&
                          solicitud.CodigoBarrasPCR !==
                            solicitud.CodigoBarrasAnticuerpos &&
                          solicitud.CodigoBarrasPCR !==
                            solicitud.CodigoBarrasAntigenos) ||
                        'Ingrese código de barras válido',
                    ]"
                    label="Código de barras"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Antígenos:
                </v-flex>
                <v-flex xs12 md9 class="pr-5" row>
                  <v-checkbox
                    :readonly="soloLectura"
                    v-model="solicitud.AnalisisAntigenos"
                  />
                  <v-text-field
                    type="number"
                    v-if="solicitud.AnalisisAntigenos"
                    :readonly="soloLectura"
                    v-model="solicitud.CodigoBarrasAntigenos"
                    :rules="[
                      () =>
                        (!!solicitud.CodigoBarrasAntigenos &&
                          String(
                            solicitud.CodigoBarrasAntigenos &&
                              solicitud.CodigoBarrasPCR !==
                                solicitud.CodigoBarrasAntigenos &&
                              solicitud.CodigoBarrasAnticuerpos !==
                                solicitud.CodigoBarrasAntigenos
                          ).length <= 10) ||
                        'Ingrese código de barras válido',
                    ]"
                    label="Código de barras"
                    :append-outer-icon="soloLectura ? 'visibility' : 'edit'"
                    @click:append-outer="abrirPreliminar('Antigenos')"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Anticuerpos:
                </v-flex>
                <v-flex xs12 md9 class="pr-5" row>
                  <v-checkbox
                    :readonly="soloLectura"
                    v-model="solicitud.AnalisisAnticuerpos"
                  />
                  <v-text-field
                    type="number"
                    v-if="solicitud.AnalisisAnticuerpos"
                    :readonly="soloLectura"
                    v-model="solicitud.CodigoBarrasAnticuerpos"
                    :rules="[
                      () =>
                        (!!solicitud.CodigoBarrasAnticuerpos &&
                          String(solicitud.CodigoBarrasAnticuerpos).length <=
                            10 &&
                          solicitud.CodigoBarrasPCR !==
                            solicitud.CodigoBarrasAnticuerpos &&
                          solicitud.CodigoBarrasAnticuerpos !==
                            solicitud.CodigoBarrasAntigenos) ||
                        'Ingrese código de barras válido',
                    ]"
                    label="Código de barras"
                    :append-outer-icon="soloLectura ? 'visibility' : 'edit'"
                    @click:append-outer="abrirPreliminar('Anticuerpos')"
                    hide-details="auto"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Fecha de la toma:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <datepicker
                    :readonly="soloLectura"
                    v-model="solicitud.FechaMuestra"
                    :rules="[
                      () => !!solicitud.FechaMuestra || 'Campo requerido',
                    ]"
                  ></datepicker>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Hora:
                </v-flex>
                <v-flex xs12 md5 class="pr-5">
                  <timepicker
                    :readonly="soloLectura"
                    v-model="solicitud.HoraMuestra"
                    :rules="[
                      () => !!solicitud.HoraMuestra || 'Campo requerido',
                    ]"
                  ></timepicker>
                </v-flex>
                <v-flex xs12 md4 class="pr-5">
                  <v-checkbox
                    :readonly="soloLectura"
                    v-model="solicitud.EsUrgente"
                    label="Urgente"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Tipo de muestra:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-checkbox
                    :rules="[
                      () =>
                        !solicitud.AnalisisPCR ||
                        !!solicitud.EsNaso ||
                        solicitud.EsOro ||
                        'Campo requerido',
                    ]"
                    :readonly="soloLectura"
                    label="Hisopado nasofaríngeo"
                    v-model="solicitud.EsNaso"
                  ></v-checkbox>
                  <v-checkbox
                    :rules="[
                      () =>
                        !solicitud.AnalisisPCR ||
                        !!solicitud.EsNaso ||
                        solicitud.EsOro ||
                        'Campo requerido',
                    ]"
                    :readonly="soloLectura"
                    label="Hisopado orofaríngeo"
                    v-model="solicitud.EsOro"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  ¿Padece alguna enfermedad?
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-radio-group
                    :readonly="soloLectura"
                    row
                    :rules="[
                      () =>
                        solicitud.PadeceEnfermedad != null || 'Campo requerido',
                    ]"
                    v-model="solicitud.PadeceEnfermedad"
                  >
                    <v-radio label="Si" :value="true"></v-radio>
                    <v-radio label="No" class="ml-2" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <template v-if="solicitud.PadeceEnfermedad">
                  <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                    ¿Cuál?
                  </v-flex>
                  <v-flex xs12 md9 class="pr-5">
                    <v-text-field
                      :readonly="soloLectura"
                      v-model="solicitud.CualEnfermedad"
                      :rules="[
                        () => !!solicitud.CualEnfermedad || 'Campo requerido',
                      ]"
                    ></v-text-field>
                  </v-flex>
                </template>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Observaciones:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-textarea
                    :rows="4"
                    v-model="solicitud.Observaciones"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 md3 class="text-h5 pt-4 pl-5">
                  Observaciones Interno:
                </v-flex>
                <v-flex xs12 md9 class="pr-5">
                  <v-textarea
                    :rows="4"
                    v-model="solicitud.ObservacionesInterno"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card>
            <v-card-title class="text-h4 primary--text">
              Referencias
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 class="text-h5 pt-4 pl-5">
                  La solicitud es por indicación personal o médica:
                </v-flex>
                <v-flex xs12 class="pl-5">
                  <v-radio-group
                    :readonly="soloLectura"
                    row
                    :rules="[
                      () =>
                        solicitud.EsIndicacionMedica != null ||
                        'Campo requerido',
                    ]"
                    v-model="solicitud.EsIndicacionMedica"
                  >
                    <v-radio label="Personal" :value="false"></v-radio>
                    <v-radio
                      label="Médica"
                      class="ml-2"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="formINDRE" v-show="paso == 4" class="d-print-block">
      <indre
        :soloLectura="soloLectura"
        v-model="solicitud.INDRE"
        :catalogos="catalogos"
      ></indre>
    </v-form>
    <v-dialog
      v-model="mostrarLecturaCodigo"
      width="50%"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
    >
      <v-card>
        <v-card-title class="text-h3 primary--text"
          >LEER CÓDIGO DE BARRAS</v-card-title
        >
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 class="text-center">
                <div id="codigoBarras"></div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn plain @click.native="mostrarLecturaCodigo = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="mostrarPreliminar"
      width="35%"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
    >
      <v-card>
        <v-card-title class="text-h3 primary--text"
          >Resultado Preliminar {{ preliminarActual }}</v-card-title
        >
        <v-card-text>
          <v-form ref="formPreliminar">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 class="text-h4">
                  Control
                </v-flex>
                <v-flex xs12>
                  <v-radio-group
                    row
                    @change="actualizarInterpretacion"
                    :readonly="soloLectura"
                    :rules="[
                      () => tmpPreliminar.Control != null || 'Campo requerido',
                    ]"
                    v-model="tmpPreliminar.Control"
                  >
                    <v-radio label="Positivo" :value="true"></v-radio>
                    <v-radio label="Negativo" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <template v-if="preliminarActual === 'Antigenos'">
                  <v-flex xs12 class="text-h4">
                    Test
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group
                      @change="actualizarInterpretacion"
                      row
                      :readonly="soloLectura"
                      :rules="[
                        () => tmpPreliminar.Test != null || 'Campo requerido',
                      ]"
                      v-model="tmpPreliminar.Test"
                    >
                      <v-radio label="Positivo" :value="true"></v-radio>
                      <v-radio label="Negativo" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 class="text-h4">
                    IgM
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group
                      @change="actualizarInterpretacion"
                      row
                      :readonly="soloLectura"
                      :rules="[
                        () => tmpPreliminar.IgM != null || 'Campo requerido',
                      ]"
                      v-model="tmpPreliminar.IgM"
                    >
                      <v-radio label="Positivo" :value="true"></v-radio>
                      <v-radio label="Negativo" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 class="text-h4">
                    IgG
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group
                      @change="actualizarInterpretacion"
                      row
                      :readonly="soloLectura"
                      :rules="[
                        () => tmpPreliminar.IgG != null || 'Campo requerido',
                      ]"
                      v-model="tmpPreliminar.IgG"
                    >
                      <v-radio label="Positivo" :value="true"></v-radio>
                      <v-radio label="Negativo" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </template>
                <template v-if="!!interpretacion">
                  <v-flex xs12 class="text-h4">
                    Interpretación
                  </v-flex>

                  <v-flex xs12 class="mb-4">
                    {{ interpretacion }}
                  </v-flex>
                </template>
                <v-flex xs12 class="text-h4">
                  <input
                    type="file"
                    accept="image/*"
                    v-show="false"
                    ref="uploadPreliminar"
                    @change="subirArchivo($event)"
                  />
                  <v-btn
                    v-if="!soloLectura"
                    :rules="[() => !!tmpPreliminar.Imagen || 'Campo requerido']"
                    color="primary"
                    @click.prevent="adjuntarImagen"
                    ><v-icon>attachment</v-icon> Adjuntar Nueva Imagen</v-btn
                  >
                  <v-btn
                    v-if="tmpPreliminar.Imagen"
                    color="primary"
                    class="ml-5"
                    @click.prevent="verImagen(tmpPreliminar.Imagen)"
                    ><v-icon>visibility</v-icon> Ver Imagen</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn plain @click.native="mostrarPreliminar = false">Cancelar</v-btn
          ><v-btn
            v-if="!soloLectura"
            color="primary"
            @click.prevent="guardarPreliminar"
            ><v-icon>save</v-icon> Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <aviso-privacidad
      @cerrar="cerrarAviso"
      v-if="mostrarAviso"
    ></aviso-privacidad>
  </section>
</template>

<script>
import datepicker from "../components/DatePicker.vue";
import timepicker from "../components/TimePicker";
import indre from "./Indre.vue";
import ServicioCatalogos from "../services/catalogos";
import ServicioMuestras from "../services/muestras";
import ServicioUpload from "../services/upload";
import Quagga from "quagga";
import ServicioLaboratorio from "../services/laboratorio";
import AvisoPrivacidad from "./AvisoPrivacidad.vue";
export default {
  name: "NuevaMuestra",
  components: { datepicker, indre, timepicker, AvisoPrivacidad },
  data() {
    return {
      paso: 1,
      completos: {
        1: false,
        2: false,
        3: false,
        4: false,
      },
      solicitud: {
        AnalisisPCR: false,
        CitaPersonaID: 0,
        Genero: null,
        EstadoNacimiento: null,
        CURP: "",
        INDRE: {},
      },
      catalogos: {
        Generos: [],
        Estados: [],
        PagosTipos: [],
      },
      hoy: new Date(),
      timeout: null,
      indreModel: {},
      mostrarLecturaCodigo: false,
      muestraID: 0,
      soloLectura: false,
      datosRespaldo: null,
      mostrarPreliminar: false,
      tmpPreliminar: {
        Imagen: null,
        Control: null,
        Test: null,
        IgG: null,
        IgM: null,
      },
      preliminarActual: "",
      interpretacion: "",
      mostrarAviso: false,
    };
  },
  methods: {
    async cerrarAviso(firma) {
      if (!!firma) {
        // Split the base64 string in data and contentType
        const block = firma.split(";");
        // Get the content type of the image
        const contentType = block[0].split(":")[1]; // In this case "image/gif"
        // get the real base64 content of the file
        const realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
        const blob = this.b64toBlob(realData, contentType);
        const imagen = new File([blob], "firma.jpg");
        const res = await ServicioUpload.uploadImage(imagen);
        this.solicitud.Firma = res.data.data.Table0[0].nuevo;
        this.guardarMuestra();
      }
      this.mostrarAviso = false;
    },
    async actualizarInterpretacion() {
      let res;
      if (
        this.preliminarActual === "Antigenos" &&
        this.tmpPreliminar.Control != null &&
        this.tmpPreliminar.Test != null
      ) {
        const data = {
          AnalisisTipoID: 3,
          Control: this.tmpPreliminar.Control,
          Test_IgM: this.tmpPreliminar.Test,
        };
        res = await ServicioLaboratorio.getInterpretacion(data);
      } else if (
        this.preliminarActual === "Anticuerpos" &&
        this.tmpPreliminar.Control != null &&
        this.tmpPreliminar.IgM != null &&
        this.tmpPreliminar.IgG != null
      ) {
        const data = {
          AnalisisTipoID: 2,
          Control: this.tmpPreliminar.Control,
          Test_IgM: this.tmpPreliminar.IgM,
          IgG: this.tmpPreliminar.IgG,
        };
        res = await ServicioLaboratorio.getInterpretacion(data);
      }
      if (!!res) {
        this.interpretacion = res.data.data.Table0[0].Interpretacion;
      } else {
        this.interpretacion = "";
      }
    },
    guardarPreliminar() {
      if (!this.$refs.formPreliminar.validate()) {
        this.$root.mensajeError =
          "Por favor llene todos los campos obligatorios.";
        return;
      }
      if (!this.tmpPreliminar.Imagen) {
        this.$root.mensajeError = "Por favor adjunte la imágen de resultados.";
        return;
      }
      this.solicitud["Preliminar" + this.preliminarActual] = {
        ...this.tmpPreliminar,
      };
      this.$refs.uploadPreliminar.value = null;
      this.mostrarPreliminar = false;
    },
    async subirArchivo(ev) {
      try {
        if (ev.target.files.length) {
          const archivo = ev.target.files[0];
          const res = await ServicioUpload.uploadImage(archivo);
          if (res.data.result === 1) {
            const archivo = res.data.data.Table0[0].nuevo;
            this.tmpPreliminar.Imagen = archivo;
          }
        }
      } catch (ex) {
        this.$root.mensajeError = "Error al subir el archivo, tamaño max 5MB.";
      }
    },
    adjuntarImagen() {
      this.$refs.uploadPreliminar.click();
    },
    abrirPreliminar(tipo) {
      this.preliminarActual = tipo;
      if (this.solicitud["Preliminar" + tipo]) {
        this.tmpPreliminar = { ...this.solicitud["Preliminar" + tipo] };
      } else {
        if (this.$refs.formPreliminar) this.$refs.formPreliminar.reset();
        this.tmpPreliminar = {
          Imagen: null,
          Control: null,
          Test: null,
          IgG: null,
          IgM: null,
        };
      }
      this.mostrarPreliminar = true;
    },
    imprimir() {
      window.print();
    },
    regresar() {
      this.$router.back();
    },
    estadoCambiado() {
      this.solicitud.DomicilioEstado = this.solicitud.NacimientoEstado;
      this.actualizarCURP();
    },
    async siguiente() {
      let forma = "";
      switch (this.paso) {
        case 1:
          forma = "formGenerales";
          break;
        case 2:
          forma = "formPago";
          break;
        case 3:
          forma = "formMuestra";
          break;
        case 4:
          forma = "formINDRE";
          break;
        default:
          forma = "formGenerales";
          break;
      }
      if (this.$refs[forma].validate()) {
        if (!(await this.validacionEspecial())) {
          return;
        }
        if (
          this.paso < 4 &&
          !(!this.solicitud.AnalisisPCR && this.paso === 3)
        ) {
          this.completos[String(this.paso)] = true;
          this.paso++;
        } else {
          if (!!this.muestraID) {
            await this.guardarMuestra();
          } else {
            this.mostrarAviso = true;
          }
        }
      } else {
        this.$root.mensajeError = "Por favor llene los campos requeridos.";
      }
    },
    async validacionEspecial() {
      if (this.paso === 3) {
        if (
          !this.solicitud.AnalisisAnticuerpos &&
          !this.solicitud.AnalisisAntigenos &&
          !this.solicitud.AnalisisPCR
        ) {
          this.$root.mensajeError =
            "Por favor seleccione al menos un tipo de Análisis";
          return false;
        }
        if (
          this.solicitud.AnalisisAntigenos &&
          !this.solicitud.PreliminarAntigenos
        ) {
          this.$root.mensajeError =
            "Por favor ingrese resultado preliminar para Antígenos";
          return false;
        }
        if (
          this.solicitud.AnalisisAnticuerpos &&
          !this.solicitud.PreliminarAnticuerpos
        ) {
          this.$root.mensajeError =
            "Por favor ingrese resultado preliminar para Anticuerpos";
          return false;
        }
        if (this.solicitud.AnalisisPCR && this.solicitud.CodigoBarrasPCR) {
          const res = await ServicioMuestras.validarCodigoBarras(
            this.solicitud.CodigoBarrasPCR
          );
          if (
            res.data.result !== 1 ||
            !res.data.data.Table0.length ||
            res.data.data.Table0[0].Resultado !== "OK"
          ) {
            this.$root.mensajeError =
              "Error en el código PCR: " + res.data.data.Table0[0].Resultado;
            return false;
          }
        }
        if (
          this.solicitud.AnalisisAntigenos &&
          this.solicitud.CodigoBarrasAntigenos
        ) {
          const res = await ServicioMuestras.validarCodigoBarras(
            this.solicitud.CodigoBarrasAntigenos
          );
          if (
            res.data.result !== 1 ||
            !res.data.data.Table0.length ||
            res.data.data.Table0[0].Resultado !== "OK"
          ) {
            this.$root.mensajeError =
              "Error en el código Antígenos: " +
              res.data.data.Table0[0].Resultado;
            return false;
          }
        }
        if (
          this.solicitud.AnalisisAnticuerpos &&
          this.solicitud.CodigoBarrasAnticuerpos
        ) {
          const res = await ServicioMuestras.validarCodigoBarras(
            this.solicitud.CodigoBarrasAnticuerpos
          );
          if (
            res.data.result !== 1 ||
            !res.data.data.Table0.length ||
            res.data.data.Table0[0].Resultado !== "OK"
          ) {
            this.$root.mensajeError =
              "Error en el código Anticuerpos: " +
              res.data.data.Table0[0].Resultado;
            return false;
          }
        }
      }
      return true;
    },
    async guardarMuestra() {
      const data = {
        MuestraID: this.muestraID,
        PreliminarAntigenos: this.solicitud.PreliminarAntigenos,
        PreliminarAnticuerpos: this.solicitud.PreliminarAnticuerpos,
        CitaPersonaID: this.solicitud.CitaPersonaID,
        CodigoBarrasPCR: this.solicitud.AnalisisPCR
          ? this.solicitud.CodigoBarrasPCR
          : 0,
        CodigoBarrasAntigenos: this.solicitud.AnalisisAntigenos
          ? this.solicitud.CodigoBarrasAntigenos
          : 0,
        CodigoBarrasAnticuerpos: this.solicitud.AnalisisAnticuerpos
          ? this.solicitud.CodigoBarrasAnticuerpos
          : 0,
        PagoTipoID: this.solicitud.PagoTipoID,
        RequiereFactura: !!this.solicitud.RequiereFactura,
        ConvenioNombre: this.solicitud.ConvenioNombre,
        FechaMuestra: `${this.solicitud.FechaMuestra}T${this.solicitud.HoraMuestra}`,
        EsUrgente: this.solicitud.EsUrgente,
        MuestraTipoID: this.solicitud.EsOro ? 2 : 1,
        Observaciones: this.solicitud.Observaciones,
        ObservacionesInterno: this.solicitud.ObservacionesInterno,
        PadeceEnfermedad: this.solicitud.PadeceEnfermedad,
        CualEnfermedad: this.solicitud.CualEnfermedad,
        EsIndicacionMedica: this.solicitud.EsIndicacionMedica,
        Paciente: {
          PacienteID: this.solicitud.PacienteID,
          PrimerApellido: this.solicitud.PrimerApellido,
          SegundoApellido: this.solicitud.SegundoApellido,
          Nombres: this.solicitud.Nombres,
          NacimientoEstadoID: this.solicitud.NacimientoEstado.EstadoID,
          FechaNacimiento: this.solicitud.FechaNacimiento,
          GeneroID: this.solicitud.Genero.GeneroID,
          CURP: this.solicitud.CURP,
          DomicilioEstadoID: this.solicitud.DomicilioEstado.EstadoID,
          CodigoPostal: this.solicitud.CodigoPostal,
          DelegacionMunicipio: this.solicitud.DelegacionMunicipio,
          CorreoCita: this.solicitud.CorreoCita,
          CorreoResultados: this.solicitud.CorreoResultados,
          Celular: this.solicitud.Celular,
          TelefonoParticular: this.solicitud.TelefonoParticular,
          Ocupacion: this.solicitud.INDRE.Ocupacion,
          RFC: this.solicitud.RFC,
          RazonSocial: this.solicitud.RazonSocial,
          DomicilioFiscal: this.solicitud.DomicilioFiscal,
          CorreoFactura: this.solicitud.CorreoFactura,
        },
        InDRE: {
          InDREID: this.solicitud.INDRE.InDREID,
          InDREExtraID: this.solicitud.INDRE.InDREExtraID,
          AlgunViaje14Dias: this.solicitud.INDRE.AlgunViaje14Dias,
          ContactoPersonaSospechosa: this.solicitud.INDRE
            .ContactoPersonaSospechosa,
          ContactoPersonaConfirmada: this.solicitud.INDRE
            .ContactoPersonaConfirmada,
          PresentaSintomas: this.solicitud.INDRE.PresentaSintomas,
          FechaInicioSintomas: this.solicitud.INDRE.FechaInicioSintomas
            ? `${this.solicitud.INDRE.FechaInicioSintomas}T00:00:00`
            : `1900-01-01T00:00:00`,
          Fiebre: this.solicitud.INDRE.Fiebre,
          Tos: this.solicitud.INDRE.Tos,
          DolorToracico: this.solicitud.INDRE.DolorToracico,
          DificultadRespiratoria: this.solicitud.INDRE.DificultadRespiratoria,
          DolorCabeza: this.solicitud.INDRE.DolorCabeza,
          Irritabilidad: this.solicitud.INDRE.Irritabilidad,
          Diarrea: this.solicitud.INDRE.Diarrea,
          Vomito: this.solicitud.INDRE.Vomito,
          DolorCuerpo: this.solicitud.INDRE.DolorCuerpo,
          CalosFrios: this.solicitud.INDRE.CalosFrios,
          DolorAbdominal: this.solicitud.INDRE.DolorAbdominal,
          DolorPasarAlimentos: this.solicitud.INDRE.DolorPasarAlimentos,
          Convulsiones: this.solicitud.INDRE.Convulsiones,
          UnasMoradas: this.solicitud.INDRE.UnasMoradas,
          DolorMuscular: this.solicitud.INDRE.DolorMuscular,
          DolorArticulaciones: this.solicitud.INDRE.DolorArticulaciones,
          CongestionNasal: this.solicitud.INDRE.CongestionNasal,
          RespiracionRapida: this.solicitud.INDRE.RespiracionRapida,
          InfeccionOjos: this.solicitud.INDRE.InfeccionOjos,
          Otros: this.solicitud.INDRE.Otros,
          RecibeTratamientoMedico: this.solicitud.INDRE.RecibeTratamientoMedico,
          QueTratamiento: this.solicitud.INDRE.QueTratamiento,
          PersonasConviveConSintomas: this.solicitud.INDRE
            .PersonasConviveConSintomas,
          ComentariosAdicionales: this.solicitud.INDRE.ComentariosAdicionales,
        },
        InDREPersonas: this.solicitud.INDRE.Personas,
        Firma: this.solicitud.Firma,
      };

      const resCrear = this.muestraID
        ? await ServicioMuestras.actualizarMuestra(data)
        : await ServicioMuestras.crearMuestra(data);
      if (resCrear.data.result === 1) {
        this.$root.mensajeExito = "La muestra se guardó exitosamente";
        this.$router.back();
      } else {
        this.$root.mensajeError = resCrear.data.message;
      }
    },
    async actualizarMuestra() {
      let valida = true;
      let paso = 1;
      if (!this.$refs.formGenerales.validate()) {
        valida = false;
        paso = 1;
      } else if (!this.$refs.formPago.validate()) {
        valida = false;
        paso = 2;
      } else if (!this.$refs.formMuestra.validate()) {
        valida = false;
        paso = 3;
      } else if (!this.$refs.formINDRE.validate()) {
        valida = false;
        paso = 4;
      }
      if (!valida) {
        this.$root.mensajeError = "Por favor llene los campos requeridos.";
        this.paso = paso;
        return;
      }
      this.guardarMuestra();
    },
    anterior() {
      this.paso--;
    },
    async obtenerCatalogos() {
      let res = await ServicioCatalogos.getEstados();
      this.catalogos.Estados = res.data.data.Table0;
      res = await ServicioCatalogos.getGeneros();
      this.catalogos.Generos = res.data.data.Table0;
      res = await ServicioCatalogos.getPagosTipos();
      this.catalogos.PagosTipos = res.data.data.Table0;
    },
    async precargarMuestra(citaPersonaID) {
      const resInfo = await ServicioMuestras.getInfoCita(citaPersonaID);
      if (resInfo.data.result === 1) {
        this.solicitud = {
          ...this.solicitud,
          ...resInfo.data.data.Table0[0],
          CitaPersonaID: citaPersonaID,
          CorreoResultados: resInfo.data.data.Table0[0].CorreoCita,
          CorreoFactura: resInfo.data.data.Table0[0].CorreoCita,
          Celular: resInfo.data.data.Table0[0].TelefonoParticular,
        };
      }
    },
    async actualizarCURP() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      const {
        Nombres,
        PrimerApellido,
        SegundoApellido,
        FechaNacimiento,
        NacimientoEstado,
        Genero,
      } = this.solicitud;
      if (
        Nombres &&
        PrimerApellido &&
        SegundoApellido &&
        FechaNacimiento &&
        NacimientoEstado &&
        Genero
      ) {
        this.timeout = setTimeout(async () => {
          const resCURP = await ServicioMuestras.getCURP(
            Nombres,
            PrimerApellido,
            SegundoApellido,
            FechaNacimiento,
            NacimientoEstado.EstadoCorto,
            Genero.GeneroCorto
          );
          if (resCURP.data.result === 1) {
            this.solicitud.CURP = resCURP.data.data.Table0[0].CURP;
          }
        }, 1000);
      }
    },
    leerCodigo() {
      this.mostrarLecturaCodigo = true;
      this.$nextTick(() => {
        Quagga.init(
          {
            inputStream: {
              name: "Live",
              type: "LiveStream",
              target: document.querySelector("#codigoBarras"), // Or '#yourElement' (optional)
              constraints: {
                width: 640,
                height: 480,
              },
            },
            decoder: {
              readers: ["ean_reader"],
              debug: {
                drawBoundingBox: true,
                drawScanline: true,
                showPattern: true,
              },
            },
          },
          function(err) {
            if (err) {
              console.log(err);
              return;
            }
            console.log("Initialization finished. Ready to start");
            Quagga.start();
          }
        );
        Quagga.onDetected((data) => {
          this.solicitud.CodigoBarras = data.codeResult.code;
          this.mostrarLecturaCodigo = false;
        });
        Quagga.onProcessed(function(result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(
                0,
                0,
                parseInt(drawingCanvas.getAttribute("width")),
                parseInt(drawingCanvas.getAttribute("height"))
              );
              result.boxes
                .filter(function(box) {
                  return box !== result.box;
                })
                .forEach(function(box) {
                  Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                    color: "green",
                    lineWidth: 2,
                  });
                });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(
                result.box,
                { x: 0, y: 1 },
                drawingCtx,
                {
                  color: "#00F",
                  lineWidth: 2,
                }
              );
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(
                result.line,
                { x: "x", y: "y" },
                drawingCtx,
                { color: "red", lineWidth: 3 }
              );
            }
          }
        });
      });
    },
    descartar() {
      this.solicitud = { ...this.datosRespaldo };
      this.soloLectura = true;
    },
  },
  watch: {
    mostrarLecturaCodigo() {
      if (!this.mostrarLecturaCodigo && Quagga) Quagga.stop();
    },
  },
  async mounted() {
    const citaPersonaID = this.$route.params.citaPersonaId;
    const muestraID = this.$route.params.muestraId;
    if (citaPersonaID && citaPersonaID !== "0") {
      await this.precargarMuestra(citaPersonaID);
    }
    await this.obtenerCatalogos();
    if (muestraID) {
      const muestraRes = await ServicioMuestras.getMuestra(muestraID);
      const data = muestraRes.data.data;
      const datosMuestra = data.Table0[0];
      const datosPersona = data.Table1[0];
      const datosIndre = data.Table2[0];
      const personasIndre = data.Table3;
      const tiposMuestras = data.Table4;
      const preliminarAntigenos = data.Table5.length ? data.Table5[0] : null;
      const preliminarAnticuerpos = data.Table6.length ? data.Table6[0] : null;
      const pcr = tiposMuestras.find((tm) => tm.AnalisisTipoID === 1);
      const anticuerpos = tiposMuestras.find((tm) => tm.AnalisisTipoID === 2);
      const antigenos = tiposMuestras.find((tm) => tm.AnalisisTipoID === 3);
      let codigos = {};
      if (pcr) {
        codigos = { AnalisisPCR: true, CodigoBarrasPCR: pcr.CodigoBarras };
      }
      if (anticuerpos) {
        codigos = {
          ...codigos,
          AnalisisAnticuerpos: true,
          CodigoBarrasAnticuerpos: anticuerpos.CodigoBarras,
        };
      }
      if (antigenos) {
        codigos = {
          ...codigos,
          AnalisisAntigenos: true,
          CodigoBarrasAntigenos: antigenos.CodigoBarras,
        };
      }
      const muestra = {
        ...this.solicitud,
        ...datosMuestra,
        ...datosPersona,
        Genero: this.catalogos.Generos.find(
          (g) => g.GeneroID === datosPersona.GeneroID
        ),
        NacimientoEstado: this.catalogos.Estados.find(
          (e) => e.EstadoID === datosPersona.NacimientoEstadoID
        ),
        DomicilioEstado: this.catalogos.Estados.find(
          (e) => e.EstadoID === datosPersona.DomicilioEstadoID
        ),
        FechaNacimiento: datosPersona.FechaNacimiento.split("T")[0],
        FechaMuestra: datosMuestra.FechaMuestra.split("T")[0],
        HoraMuestra: datosMuestra.FechaMuestra.split("T")[1],
        EsOro: datosMuestra.MuestraTipoID === 2,
        EsNaso: datosMuestra.MuestraTipoID === 1,
        INDRE: {
          ...datosIndre,
          Ocupacion: datosPersona.Ocupacion,
          FechaInicioSintomas:
            !datosIndre.FechaInicioSintomas ||
            datosIndre.FechaInicioSintomas.indexOf("1900") > -1
              ? ""
              : datosIndre.FechaInicioSintomas.split("T")[0],
          Personas: [...personasIndre],
        },
        PreliminarAntigenos: preliminarAntigenos,
        PreliminarAnticuerpos: preliminarAnticuerpos,
        ...codigos,
      };
      this.soloLectura = true;
      this.datosRespaldo = { ...muestra };
      this.solicitud = muestra;
      this.muestraID = muestraID;
    } else {
      this.solicitud.FechaMuestra = this.fechaPicker(this.hoy);
      this.solicitud.HoraMuestra = this.horaFecha(this.hoy);
    }
  },
  computed: {
    requiereINDRE() {
      return !!this.solicitud.AnalisisPCR;
    },
  },
};
</script>

<style>
#codigoBarras {
  height: auto;
  width: 100%;
}
canvas {
  max-width: 100%;
}
canvas.drawingBuffer {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
